"use strict";

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Resizable } from 'react-resizable';
import { DraggableCore } from 'react-draggable';
import classNames from 'classnames';

function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = _objectSpread({}, element.props.style, props.style);
  }

  if (props.className && element.props.className) {
    props.className = "".concat(element.props.className, " ").concat(props.className);
  }

  return React.cloneElement(element, props);
}

var styles = function styles(theme) {
  return {
    resizableHandle: {
      position: 'absolute',
      height: '100%',
      bottom: 0,
      padding: '0 3px 3px 0',
      // background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+') no-repeat bottom right;
      // background-origin: content-box;
      boxSizing: 'border-box',
      cursor: 'col-resize',
      zIndex: 99999
    },
    'resizableHandle-left': {
      right: 0
    },
    'resizableHandle-right': {
      left: 0
    },
    maxHeightClass: {
      height: '100%'
    },
    resizableBox: _defineProperty({
      position: 'absolute'
    }, theme.breakpoints.up('md'), {
      position: 'relative'
    }),
    'resizableBox-left': {
      left: 0,
      right: 'auto'
    },
    'resizableBox-right': {
      right: 0,
      left: 'auto'
    }
  };
};

var CustomResizableBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CustomResizableBox, _React$Component);

  function CustomResizableBox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CustomResizableBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CustomResizableBox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: _this.props.width,
      height: _this.props.height
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function (e, data) {
      var size = data.size;

      if (_this.props.onResize) {
        e.persist && e.persist();

        _this.setState(size, function () {
          return _this.props.onResize && _this.props.onResize(e, data);
        });
      } else {
        _this.setState(size);
      }
    });

    return _this;
  }

  _createClass(CustomResizableBox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
        this.setState({
          width: nextProps.width,
          height: nextProps.height
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSize = _this$props.handleSize,
          onResize = _this$props.onResize,
          onResizeStart = _this$props.onResizeStart,
          onResizeStop = _this$props.onResizeStop,
          draggableOpts = _this$props.draggableOpts,
          classes = _this$props.classes,
          direction = _this$props.direction,
          minConstraints = _this$props.minConstraints,
          maxConstraints = _this$props.maxConstraints,
          lockAspectRatio = _this$props.lockAspectRatio,
          axis = _this$props.axis,
          props = _objectWithoutProperties(_this$props, ["handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "classes", "direction", "minConstraints", "maxConstraints", "lockAspectRatio", "axis"]);

      var _this$state = this.state,
          width = _this$state.width,
          height = _this$state.height;
      return React.createElement(CustomResizable, {
        handleSize: handleSize,
        width: width,
        height: height,
        onResizeStart: onResizeStart,
        onResize: this.onResize,
        onResizeStop: onResizeStop,
        draggableOpts: draggableOpts,
        minConstraints: minConstraints,
        maxConstraints: maxConstraints,
        lockAspectRatio: lockAspectRatio,
        axis: axis,
        direction: direction // maxConstraints={[250, 250]}
        ,
        className: classes.maxHeightClass
      }, React.createElement("div", _extends({
        className: classNames(classes.resizableBox, classes["resizableBox-".concat(direction)]),
        style: {
          width: "".concat(width, "px")
        }
      }, props)));
    }
  }]);

  return CustomResizableBox;
}(React.Component);

_defineProperty(CustomResizableBox, "propTypes", {
  height: PropTypes.number,
  width: PropTypes.number,
  direction: PropTypes.string,
  classes: PropTypes.object.isRequired
});

_defineProperty(CustomResizableBox, "defaultProps", {
  handleSize: [20, 20],
  direction: 'left'
});

var CustomResizable =
/*#__PURE__*/
function (_Resizable) {
  _inherits(CustomResizable, _Resizable);

  function CustomResizable() {
    _classCallCheck(this, CustomResizable);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomResizable).apply(this, arguments));
  }

  _createClass(CustomResizable, [{
    key: "resizeHandler",

    /**
     * Wrapper around drag events to provide more useful data.
     *
     * @param  {String} handlerName Handler name to wrap.
     * @return {Function}           Handler function.
     */
    value: function resizeHandler(handlerName) {
      var _this2 = this;

      return function (e, coreEvent) {
        var node = coreEvent.node,
            deltaX = coreEvent.deltaX,
            deltaY = coreEvent.deltaY,
            x = coreEvent.x; // Axis restrictions

        var canDragX = _this2.props.axis === 'both' || _this2.props.axis === 'x';
        var canDragY = _this2.props.axis === 'both' || _this2.props.axis === 'y'; // Update w/h

        var width;
        if (_this2.props.direction === 'left') width = _this2.state.width + (canDragX ? deltaX : 0);else width = _this2.state.width + (canDragX ? -x : 0);
        var height = _this2.state.height + (canDragY ? deltaY : 0); // Early return if no change

        var widthChanged = width !== _this2.state.width,
            heightChanged = height !== _this2.state.height;
        if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;

        var _this2$runConstraints = _this2.runConstraints(width, height);

        var _this2$runConstraints2 = _slicedToArray(_this2$runConstraints, 2);

        width = _this2$runConstraints2[0];
        height = _this2$runConstraints2[1];
        // Set the appropriate state for this handler.
        var newState = {};

        if (handlerName === 'onResizeStart') {
          newState.resizing = true;
        } else if (handlerName === 'onResizeStop') {
          newState.resizing = false;
          newState.slackW = newState.slackH = 0;
        } else {
          // Early return if no change after constraints
          if (width === _this2.state.width && height === _this2.state.height) return;
          newState.width = width;
          newState.height = height;
        }

        var hasCb = typeof _this2.props[handlerName] === 'function';

        if (hasCb) {
          if (typeof e.persist === 'function') e.persist();

          _this2.setState(newState, function () {
            return _this2.props[handlerName](e, {
              node: node,
              size: {
                width: width,
                height: height
              }
            });
          });
        } else {
          _this2.setState(newState);
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          draggableOpts = _this$props2.draggableOpts,
          width = _this$props2.width,
          height = _this$props2.height,
          handleSize = _this$props2.handleSize,
          classes = _this$props2.classes,
          lockAspectRatio = _this$props2.lockAspectRatio,
          axis = _this$props2.axis,
          minConstraints = _this$props2.minConstraints,
          maxConstraints = _this$props2.maxConstraints,
          onResize = _this$props2.onResize,
          onResizeStop = _this$props2.onResizeStop,
          onResizeStart = _this$props2.onResizeStart,
          direction = _this$props2.direction,
          p = _objectWithoutProperties(_this$props2, ["children", "draggableOpts", "width", "height", "handleSize", "classes", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "direction"]);

      var className = p.className ? "".concat(p.className, " react-resizable") : 'react-resizable'; // What we're doing here is getting the child of this element, and cloning it with this element's props.
      // We are then defining its children as:
      // Its original children (resizable's child's children), and
      // A draggable handle.

      return cloneElement(children, _objectSpread({}, p, {
        className: className,
        children: [children.props.children, React.createElement(DraggableCore, _extends({}, draggableOpts, {
          key: "resizableHandle",
          onStop: this.resizeHandler('onResizeStop'),
          onStart: this.resizeHandler('onResizeStart'),
          onDrag: this.resizeHandler('onResize')
        }), React.createElement("span", {
          className: classNames(classes.resizableHandle, classes["resizableHandle-".concat(direction)])
        }))]
      }));
    }
  }]);

  return CustomResizable;
}(Resizable);

CustomResizable = withStyles(styles)(CustomResizable);
export default withStyles(styles)(CustomResizableBox);